// Lottie award animations — imported once here and referenced by badge
import achievementAnim    from '../assets/lottie/awards/Achievement.json';
import starBadgeAnim      from '../assets/lottie/awards/Star Badge.json';
import firstMedalAnim     from '../assets/lottie/awards/First Medal.json';
import hexMedalAnim       from '../assets/lottie/awards/Hexagonal Medal.json';
import firstPlaceAnim     from '../assets/lottie/awards/First Place Badge.json';
import georgianCrownAnim  from '../assets/lottie/awards/Georgian Crown.json';
import diamondAnim        from '../assets/lottie/awards/Diamond.json';
import kingsCrownAnim     from '../assets/lottie/awards/Kings Crown.json';
import royalCrownAnim     from '../assets/lottie/awards/Royal Crown.json';
import trophyAnim         from '../assets/lottie/awards/Trophy.json';

export interface StreakBadge {
  days: number;
  /** Lottie animation data object */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lottie: any;
  name: string;
  description: string;
}

export const STREAK_BADGES: StreakBadge[] = [
  { days: 7,    lottie: achievementAnim,   name: 'Seedling',     description: 'First week complete'      },
  { days: 14,   lottie: starBadgeAnim,     name: 'Charged',      description: 'Two weeks strong'         },
  { days: 28,   lottie: firstMedalAnim,    name: 'On Fire',      description: 'One full month'           },
  { days: 56,   lottie: hexMedalAnim,      name: 'Committed',    description: 'Two months of effort'     },
  { days: 100,  lottie: firstPlaceAnim,    name: 'Century',      description: '100 days — remarkable'    },
  { days: 180,  lottie: georgianCrownAnim, name: 'Half Year',    description: 'Six months of dedication' },
  { days: 200,  lottie: diamondAnim,       name: 'Diamond',      description: '200 days of consistency'  },
  { days: 365,  lottie: kingsCrownAnim,    name: 'Elite',        description: 'A full year logged'       },
  { days: 500,  lottie: royalCrownAnim,    name: 'Unstoppable',  description: '500 days and counting'    },
  { days: 1000, lottie: trophyAnim,        name: 'Legend',       description: '1000 days — all time'     },
];

/** All badges whose threshold the current streak has met or passed. */
export function getEarnedBadges(currentStreak: number): StreakBadge[] {
  return STREAK_BADGES.filter((b) => currentStreak >= b.days);
}

/** The next badge the user is working toward (first unearned). */
export function getNextBadge(currentStreak: number): StreakBadge | null {
  return STREAK_BADGES.find((b) => currentStreak < b.days) ?? null;
}

/** The most recently earned badge milestone (for progress bar start). */
export function getLastMilestone(currentStreak: number): number {
  const earned = getEarnedBadges(currentStreak);
  return earned.length > 0 ? earned[earned.length - 1].days : 0;
}

/**
 * Progress (0–1) between the last earned badge and the next badge.
 * Returns 1 if all badges are earned.
 */
export function getBadgeProgress(currentStreak: number): number {
  const next = getNextBadge(currentStreak);
  if (!next) return 1;
  const last = getLastMilestone(currentStreak);
  const range = next.days - last;
  const progress = currentStreak - last;
  return Math.min(progress / range, 1);
}
